export enum DragType {
  moonCell = 'moonCell'
}
